import * as React from 'react';
import { SVGProps } from 'react';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const HoodIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 47 43"
    fill="none"
    {...props}
  >
    <path
      stroke="#FF9800"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.557 4.294 5.119 11.76c-2.825 1.57-2.825 5.63 0 7.2l13.438 7.465a10.302 10.302 0 0 0 9.998 0l13.438-7.465c2.825-1.57 2.825-5.63 0-7.2L28.555 4.294a10.301 10.301 0 0 0-9.998 0Z"
    />
    <path
      stroke="#FF9800"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.477 21.935v8.54a6.167 6.167 0 0 0 2.752 5.135l3.497 2.327a12.332 12.332 0 0 0 13.658 0l3.497-2.327a6.164 6.164 0 0 0 2.751-5.134v-8.54"
    />
  </svg>
);
export default HoodIcon;
